import { render, staticRenderFns } from "./DashboardUsersInviteModal.vue?vue&type=template&id=5d2d218b&"
import script from "./DashboardUsersInviteModal.vue?vue&type=script&lang=js&"
export * from "./DashboardUsersInviteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports